import React from 'react'

function PortalReportesScreen() {
  return (
    <div>PortalReportesScreen</div>
  )
}

export default PortalReportesScreen